import { render, staticRenderFns } from "./AtomRadioButton2.vue?vue&type=template&id=4bf233d5&scoped=true&"
import script from "./AtomRadioButton2.vue?vue&type=script&lang=ts&"
export * from "./AtomRadioButton2.vue?vue&type=script&lang=ts&"
import style0 from "./AtomRadioButton2.vue?vue&type=style&index=0&id=4bf233d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf233d5",
  null
  
)

export default component.exports